import {IController, IScope} from "angular";
import * as angular from "angular";

export class PlanningProjectOverviewComponent implements IController {
  project: any;
  onEdit: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectOverview', {
    bindings: {
      project: '<?',
      onEdit: '&'
    },
    template: require('./planning-project-overview.html').default,
    controller: PlanningProjectOverviewComponent
  });
